export const FEATURE_NAMESPACE = 'feature.risk-survey'
